import { ApiProperty } from "@nestjs/swagger";


export class CompanyModuleIdRequest {
    @ApiProperty()
    companyId: number;
    @ApiProperty()
    moduleId: number;

    /**
     * 
     * @param companyId 
     * @param moduleId 
     */
    constructor(companyId: number, moduleId: number) {
        this.companyId = companyId;
        this.moduleId = moduleId;
    }
}
export class CompanyIdReq{
    @ApiProperty()
    companyId:number;
}